import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './providers/AuthProvider'
import { PasswordGate } from './components/PasswordGate'
import { Layout } from './components/Layout'
import { Dashboard } from './pages/Dashboard'
import { Traffic } from './pages/Traffic'
import { Features } from './pages/Features'
import { Geography } from './pages/Geography'
import { Devices } from './pages/Devices'

function ProtectedRoutes() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <PasswordGate />
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/traffic" element={<Traffic />} />
        <Route path="/features" element={<Features />} />
        <Route path="/geography" element={<Geography />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <ProtectedRoutes />
    </BrowserRouter>
  )
}
